import {Box} from '@mui/material';
import {Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import TopBar from './TopBar';

export const RMCLayout = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <TopBar />
      <Box
        sx={{
          flex: 1,
          mt: '64px', // Height of TopBar
          width: '100%',
        }}
      >
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};
